type DurationType = {
  seconds?: number,
  minutes?: number,
  hours?: number,
  days?: number,
}

export type TimeRangeType = {
  type: string,
  duration: DurationType,
  fromDate?: string,
  toDate?: string,
}

// Duration is negative for these constants, as it's used to calculate a time range relative to its end date
export const RELATIVE_TIME_RANGES: TimeRangeType[] = [
  { type: 'Last 30 seconds', duration: { seconds: -30 } },
  { type: 'Last 60 seconds', duration: { seconds: -60 } },
  { type: 'Last 5 minutes', duration: { minutes: -5 } },
  { type: 'Last 15 minutes', duration: { minutes: -15 } },
  { type: 'Last 30 minutes', duration: { minutes: -30 } },
  { type: 'Last hour', duration: { hours: -1 } },
  { type: 'Last 3 hours', duration: { hours: -3 } },
  { type: 'Last 6 hours', duration: { hours: -6 } },
  { type: 'Last 12 hours', duration: { hours: -12 } },
  { type: 'Last day', duration: { days: -1 } },
  { type: 'Last 2 days', duration: { days: -2 } },
  { type: 'Last 7 days', duration: { days: -7 } },
];
